import { render, staticRenderFns } from "./empleado.vue?vue&type=template&id=5bdcd44a&scoped=true"
import script from "./empleado.vue?vue&type=script&lang=js"
export * from "./empleado.vue?vue&type=script&lang=js"
import style0 from "./empleado.vue?vue&type=style&index=0&id=5bdcd44a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdcd44a",
  null
  
)

export default component.exports